import { FlightClass } from '../../models';
import { SegmentParams } from './composeSegmentParams';
import { composeTimeSelectParams } from './composeTimeSelectParams';

const composePaxParams = (pax) => {
    const { adults, kids, infants } = pax;
    let url = '';
    if (adults > 1) {
        url += `;adults=${adults}`;
    }
    if (kids > 0) {
        url += `;children=${kids}`;
    }
    if (infants > 0) {
        url += `;infants=${infants}`;
    }
    return url;
};

const composeAgeParams = (pax) => {
    const DEFAULT_AGE_INFANTS = 1;
    const DEFAULT_TRAIN_AGE_CHILDREN = 10;
    const DEFAULT_AGE_ADULTS = 30;
    const { adults, kids, infants } = pax;
    let url = '';
    let adultAges = '';
    let childrenAges = '';
    let infantAges = '';
    if (adults > 0) {
        adultAges = `;adultAges=${DEFAULT_AGE_ADULTS}`;
        for (let i = 1; i < adults; i++) {
            adultAges += `-${DEFAULT_AGE_ADULTS}`;
        }
    }
    if (kids > 0) {
        childrenAges = `;childrenAges=${DEFAULT_TRAIN_AGE_CHILDREN}`;
        for (let i = 1; i < kids; i++) {
            childrenAges += `-${DEFAULT_TRAIN_AGE_CHILDREN}`;
        }
    }
    if (infants > 0) {
        infantAges = `;infantAges=${DEFAULT_AGE_INFANTS}`;
        for (let i = 1; i < infants; i++) {
            infantAges += `-${DEFAULT_AGE_INFANTS}`;
        }
    }
    url += `${adultAges}${childrenAges}${infantAges}`;
    return url;
};

export const composeFlightsParams = (search) => {
    const {
        cabinClass,
        isDirect,
        pax,
        airlineFilter,
        trainSearch
    } = search;
    let url = SegmentParams.compose(search);

    if (cabinClass !== FlightClass.TOURIST && !trainSearch) {
        url += `;class=${cabinClass}`;
    }

    if (isDirect) {
        url += ';direct=true';
    }

    url += composePaxParams(pax);
    if (trainSearch) {
        url += composeAgeParams(pax);
        url += composeTimeSelectParams(search.segments);
    }

    if (airlineFilter && airlineFilter.enabled) {
        url += `;airlinescodes=${airlineFilter.airlineIata}`;
    }

    return url;
};
